import { connect } from 'react-redux'
import { change } from 'redux-form'
import { bindActionCreators } from 'redux'

import store from '../../store'
import { SeatTradeSearchResultsFormName } from '../../config/forms'

import { v1requestSeatTrade } from '../../actions/seatTrade'
import { v1requestFilteredTourOperators } from '../../actions/tourOperators'

import SeatTradeMenu from '../../components/SeatTradeMenu'

export const mapStateToProps = state => {
  const {
    v1tourOperators: { filteredTourOperators },
    form: { SeatTrade: SeatTradeForm },
  } = state

  const tourOperatorsOptions =
    filteredTourOperators &&
    filteredTourOperators.map(tourOperator => ({
      value: tourOperator,
      label: `${tourOperator.code} - ${tourOperator.name} (${
        tourOperator.market
      })`,
    }))

  const form = SeatTradeForm ? SeatTradeForm : {}
  const seatTradeFormValues = Object.keys(form.values || {})
  const isSeatTradeValid = Boolean(
    seatTradeFormValues.length >= 2 &&
      seatTradeFormValues.includes('tourOperator') &&
      !form.syncErrors
  )

  return {
    tourOperatorsOptions,
    isSeatTradeValid,
  }
}

const seatTradeFormFieldsToFilter = [
  'startDate',
  'endDate',
  'departureAirport',
  'arrivalAirport',
  'tourOperator',
]

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        requestFilteredTourOperators: v1requestFilteredTourOperators,
      },
      dispatch
    ),
    resetTouroperatorField: () => {
      dispatch(change(SeatTradeSearchResultsFormName, 'tourOperator', ''))
    },
    onSeatTrade: () => {
      // Since we do not have access to the seat trade form
      // when submitting we'll need to manually grab it.
      const { form } = store.getState()
      const seatTradeFormValues = form[SeatTradeSearchResultsFormName].values

      const seatTrades = Object.keys(seatTradeFormValues).reduce(
        (collection, value) => {
          if (seatTradeFormFieldsToFilter.includes(value)) return collection

          return [
            ...collection,
            {
              flightId: value,
              seats: seatTradeFormValues[value][value],
            },
          ]
        },
        []
      )

      dispatch(
        v1requestSeatTrade({
          tourOperator: seatTradeFormValues.tourOperator,
          seatTrades,
        })
      )
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SeatTradeMenu)
